export default __webpack_public_path__ + "static/media/splash-title.6abcc2fe.png";